module.exports = __webpack_public_path__ + "img/PorkFinland.987b6e85.png";